export type ListDetailsTranslation = {
  avatar: {
    you: string;
  };
  date: {
    daysAgo: PluralForms;
    inDays: PluralForms;
    monthsAgo: PluralForms;
    never: string;
    overdueBy: PluralForms;
    today: string;
    tomorrow: string;
    weeksAgo: PluralForms;
    yearAgo: string;
    yesterday: string;
  };
  row: {
    collapse: string;
    error: string;
    expand: string;
    more: string;
  };
  sections: {
    activeProcesses: string;
    contactInfo: string;
    contacts: string;
    details: string;
    noActiveProcesses: string;
    noContactInfo: string;
    noContacts: string;
    noOpenTasks: string;
    openTasks: string;
  };
};

type PluralForms = {
  few: string;
  many: string;
  one: string;
};

export const listDetailsTranslation: ListDetailsTranslation = {
  avatar: {
    you: 'Ty',
  },
  date: {
    daysAgo: { few: '{{count}} dni temu', many: '{{count}} dni temu', one: 'wczoraj' },
    inDays: { few: 'za {{count}} dni', many: 'za {{count}} dni', one: 'jutro' },
    monthsAgo: {
      few: '{{count}} miesiące temu',
      many: '{{count}} miesięcy temu',
      one: 'miesiąc temu',
    },
    never: 'nigdy',
    overdueBy: {
      few: 'Po terminie: {{count}} dni',
      many: 'Po terminie: {{count}} dni',
      one: 'Po terminie: 1 dzień',
    },
    today: 'dziś',
    tomorrow: 'jutro',
    weeksAgo: {
      few: '{{count}} tygodnie temu',
      many: '{{count}} tygodni temu',
      one: 'tydzień temu',
    },
    yearAgo: 'ponad rok temu',
    yesterday: 'wczoraj',
  },
  row: {
    collapse: 'Ukryj szczegóły',
    error: 'Nie udało się pobrać szczegółów',
    expand: 'Pokaż szczegóły',
    more: 'i {{count}} więcej',
  },
  sections: {
    activeProcesses: 'Aktywne procesy',
    contactInfo: 'Dane kontaktowe',
    contacts: 'Kontakty',
    details: 'Szczegóły',
    noActiveProcesses: 'Brak aktywnych procesów',
    noContactInfo: 'Brak telefonu i e-maila',
    noContacts: 'Brak kontaktów',
    noOpenTasks: 'Nic do zrobienia',
    openTasks: 'Do zrobienia',
  },
};
